import React , {useState , useEffect} from 'react';
import {NavLink,useHistory} from 'react-router-dom';
import {ResGet} from './component/resapi'
import Div100vh from 'react-div-100vh'
const HeaderTwo = (props)=> {
  const [_isactive,set_isactive] = useState(false);
  
  const handelClickMenu=(ev)=>{
    if(props.active){
      props.close()
    }
    else {
      set_isactive(value=>!value)
    }
  }
  return (
    <React.Fragment>
      <div className={props.w?"menu w":"menu"}>
        <button  className={`menu-toggle clickable ${_isactive || props.active?"active":""}`} id="menu-toggle" onClick={handelClickMenu}>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
        </button>
      </div>
      <div className={props.w?"logo w":"logo"}><NavLink to="/"><span className="logo_light clickable"></span></NavLink></div>
      
      <Div100vh className={`popupmenu ${_isactive || props.active?"active":""}`} style={{height:"100rvh",overflow:"hidden"}}>
          {props.active?
            props.children
            :
            _isactive?<Popup onClose={()=>set_isactive(false)}/>:""
          }

      </Div100vh>
       
    </React.Fragment>
  );
}
const Popup = ({onClose})=>{
  
  let history = useHistory();
  const [inputSearch,setinputSearch] =  useState("");
  const [_istyping,setistyping] =  useState(false);
  const [social, setsocial] = useState({});
  const [loading,setloading] = useState(true)
  useEffect(() => {
    ResGet("getabout").then((response)=>{
      if(response.status===200){
        if(response.data.length>0 && response.data[response.data.length-1].soical){
          setsocial(response.data[response.data.length-1].soical)
        }
        setloading(false)
      }
    })
  },[])
  const handelSearch =(event)=>{
    if (event.key === 'Enter') {
      if(history.location.pathname.includes("search/")){
        onClose()
      }
      if(inputSearch!=="") history.push(`/search/${inputSearch}`);
    }
  }
  return(
    <>
        <div className="social">
        {!loading?
          <>
          <a href={social.facebook} rel="noopener noreferrer" target="_blank" className="clickable"><i className="icon icon-facebook"></i></a>
          <a href={social.linkedin} rel="noopener noreferrer" target="_blank" className="clickable"><i className="icon icon-linkedin"></i></a>
          <a href={social.twitter} rel="noopener noreferrer" target="_blank" className="clickable"><i className="icon icon-twitter"></i></a>
          <a href={social.instagram} rel="noopener noreferrer" target="_blank" className="clickable"><i className="icon icon-instagram"></i></a>
          </>
        :""}
        </div>
        <div className="content">
          <ul>
            <li className="hoverline"><NavLink exact to="/" className="clickable">Home</NavLink></li>
            <li className="hoverline"><NavLink to="/work" className="clickable">Work</NavLink></li>
            <li className="hoverline"><NavLink to="/archive" className="clickable">Archive</NavLink></li>
            <li className="hoverline"><NavLink to="/about" className="clickable">About</NavLink></li>  
            <li className="hoverline"><NavLink to="/contact" className="clickable">Contact</NavLink></li> 
            <li className="hoverline clickable">
            <label>
            <input type="text" className="clickable"
                     value={inputSearch}
                     placeholder={"SEARCH"}
                     onBlur={()=>{
                       setinputSearch("") 
                       setistyping(false)}
                     }
                     onFocus={()=>setistyping(true)}
                     onChange={ev => setinputSearch(ev.target.value)}
                     onKeyDown={ev=>handelSearch(ev)}
              />
              <span>
                {_istyping && inputSearch===""?<span>|</span>:""}
                {inputSearch==="" && !_istyping?"SEARCH":inputSearch}
                </span>
              </label>
              </li> 
          </ul>
        </div>
        <div className="slogan">
        Redefining the <span>Simplicity</span>
        </div>
    </>
  )
}



export default HeaderTwo;
